import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { User } from '../../models/data.types'
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';

// Import navigation elements
import { MenuService,NavigrationParentItem,NavigrationChildItem, NavigationCollection } from './../../services/index';

@Component({
  selector: 'app-sidebar-nav',
  providers: [MenuService],
  template: `
 
  <!--
<div class="btn-group" dropdown  *ngIf="user.isDeveloper && currentProfileId > 0" style="padding-bottom: 30px;">
  <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle" style="  width: 200px;  height: 35px;"> 
    Profile: {{currentProfileName}}<span class="caret"></span>
  </button>
  <ul *dropdownMenu class="dropdown-menu"  role="menu">
    <li role="profileItem" *ngFor="let x of (profileMenus | async)" >
      <a class="dropdown-item"  (click)="getUrls(x.id,x.name)">
      Profile: {{x.name}}
      </a>
    </li>
  </ul> 
</div>	



<li role="profileItem" *ngFor="let navitem of (navigationCollection | async)?.allUrls"  >
   {{navitem.name}}
</li>
-->

  <div [hidden]="!ShowFavoriteOnly()">
    <nav class="sidebar-nav" >
      <ul class="nav">
      <ng-container  *ngFor="let navitem of (navigationCollection | async)?.favoriteUrls" >
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template >
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isDivider(navitem)">
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          </ng-template>
        </ng-container >
       </ul>
    </nav>
  </div>
 
  <div [hidden]="ShowFavoriteOnly()">
  <nav class="sidebar-nav" >
  <ul class="nav" >
  <ng-container  *ngFor="let navitem of (navigationCollection | async)?.allUrls" >
      <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
      <ng-template>
        <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
      </ng-template>
      <ng-template [ngIf]="!isDivider(navitem)">
        <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
      </ng-template>
    </ng-container>
  </ul>
  </nav>
  </div>`
})
export class AppSidebarNavComponent  {

  private currentProfileId : number
  private currentProfileName : String
  private user: User;

  private profileMenus : Promise<any[]>;
  private navigationCollection : Promise<NavigationCollection>;
  
  constructor(private navSvc:MenuService,
              private apiService: ApiService) {

                this.user = JSON.parse(localStorage.getItem('currentUser'));

                this.currentProfileId = this.user.ProfileId;
                this.currentProfileName = this.user.ProfileName;

                this.navigationCollection =  this.navSvc.LoadUrls();
               }

  public isDivider(item) {
    return item.divider ? true : false
  }

  ShowFavoriteOnly(){
    return (Boolean)(JSON.parse(localStorage.getItem("showFavOnly")));
  }

  GetProfileMenuIds():   Promise<any[]> {
   
      return   this.apiService.postAs<any>('data/doquery/CW_GetProfileMenuIds',null).then(
        response => {
              return  response.Items;
      }
    )
 }
 
  getUrls(profileId: number,profileName: String) {
       
    this.navigationCollection = null;

    // this.currentProfileId = profileId;
    // this.currentProfileName = profileName;
    
    // this.navigationCollection = this.navSvc.LoadUrls(this.currentProfileId);
  }



}

import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
      <app-sidebar-nav-link   [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template  #dropdown>
      <li
          [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown  [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>

    `
})

export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public hasChildren() {
    return this.item.children != null && this.item.children.length > 0;
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }

  constructor( private router: Router )  { }

}


@Component({
  selector: 'app-sidebar-nav-link',
  template: `
  <style>
  .star {
    font-size: 25px;
    color:gold;
  }
  </style>
    <a *ngIf="!isExternalLink(); else external"
      [target]="isOpenInWindow()"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      [routerLink]="[link.url]"
      (click)="hideMobile()">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <a *ngIf="!isExternalLink();" class="float-right" (click)="ToggleFavroite()"><i class="fa fa-{{ link.isfavorite }} text-warning"></i></a>
    <ng-template #external>
      <a *ngIf="isKiosk(); else portal"
        [target]="isOpenInWindow()"
        [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" 
        [href]="link.url" 
      >
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
      <ng-template #portal>
        <a
          [target]="isOpenInWindow()"
          [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" 
          [routerLink]="['/Dashboard/Scheid/'+link.system+'/portal-container']" 
          [queryParams]="{portal: link.applicationid}"
          routerLinkActive="active"
        >
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
        </a>
      </ng-template>
      <a class="float-right" (click)="ToggleFavroite()"><i class="fa fa-{{ link.isfavorite }} text-warning"></i></a>
    </ng-template>
     
   
  `
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isKiosk() {
    return this.link.type == 'kiosk' ? true : false;
  }

  public isOpenInWindow() {
    return this.link.tab ? '_blank' : '_self';
  }  

  public isBadge() {
    return this.link.badge != null ?this.link.badge ? true : false : false;
  }

  public isExternalLink() {
    return this.link.url != null ? this.link.url.substring(0, 4) === 'http'  || this.link.applicationid != '' ? true : false : false;
  }

  public isIcon() {
    return this.link.icon != null ? this.link.icon ? true : false : false;
  }

  public hideMobile() {
    if (document.body.classList.contains('sidebar-mobile-show')) {
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }

  public ToggleFavroite() {
   console.log(this.link);
    let body = JSON.parse('{"username": "'+this.link.username+'","menuid":"'+this.link.menuid+'"}');
    this.apiService.postAs<any>('data/doquery/CW-PortalMenuToggleFavorite',body).then(
     response => {

      this.link.isfavorite = response.Item.isfavorite;
     }
    )
 }

  constructor(private apiService: ApiService) { }
}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a *ngIf="isValid()" class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul  *ngIf="isValid()"  class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  public isValid() {
    return this.link.isValid ? true : false
  }

  constructor() { }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if ( this.title.class ) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if ( this.title.wrapper ) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts